import React from 'react';
import { Box, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import KpiCard from '../components/dashboard/KpiCard';
import EcosystemGraph from '../components/dashboard/EcosystemGraph';
import { mockUsers, mockProjects, mockResources } from '../data/mockData';

const Dashboard: React.FC = () => {
  const emprendedoresCount = mockUsers.filter(u => u.role === 'Emprendedor').length;
  const mentoresCount = mockUsers.filter(u => u.role === 'Mentor').length;
  const projectsCount = mockProjects.length;
  const resourcesCount = mockResources.length;

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Dashboard - Ecosistema de Innovación
      </Typography>

      {/* KPI Cards */}
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 3, mb: 4 }}>
        <KpiCard
          title="Total Emprendedores"
          value={emprendedoresCount}
          icon={<PeopleIcon />}
          color="#2196F3"
        />
        <KpiCard
          title="Total Mentores"
          value={mentoresCount}
          icon={<HandshakeIcon />}
          color="#4CAF50"
        />
        <KpiCard
          title="Proyectos Activos"
          value={projectsCount}
          icon={<BusinessIcon />}
          color="#FF9800"
        />
        <KpiCard
          title="Recursos Disponibles"
          value={resourcesCount}
          icon={<SchoolIcon />}
          color="#9C27B0"
        />
      </Box>

      {/* Ecosystem Graph */}
      <EcosystemGraph />
    </Box>
  );
};

export default Dashboard;
